import { COLORS } from "@/constants";
import styled from "styled-components";

export const Box = styled.div<{ $bg?: string }>`
  background-color: ${({ $bg }) => $bg ?? COLORS["beige-cream"]};
  border-radius: 8px;
  padding: 30px 50px 30px 220px;
  position: relative;

  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 760px) {
    flex-direction: column;
    align-items: center;
    padding: 24px 20px 32px;
    overflow: visible;
    text-align: center;
  }
`;

export const Img = styled.div`
  position: absolute;
  width: 146px;
  height: 189px;
  bottom: -8px;
  left: 44px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 760px) {
    position: static;
    width: 120px;
    height: 130px;
    margin-top: -40px;
  }
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 670px;

  @media (max-width: 760px) {
    max-width: 100%;
    align-items: center;
    text-align: center;
  }
`;